// Inverse linear interpolation where start == value corresponds to 0 and end == value to 1
export default function inverseLerp(start: number, end: number, value: number): number {
  return (value - start) / (end - start);
}
